export default "__VITE_ASSET__e8e16f8d__"